import { Component, OnInit } from '@angular/core';
import { Supply } from '../../../../models/configurators-2d/applications/decking-boards/supply';
import { DeckingBoardsService } from '../../../../services/configurators-2d/applications/decking-boards.service';
import { TranslateService } from '@ngx-translate/core';
import { DeckingBoardsConfiguratorItem } from '../../configurator/applications/decking-boards-configurator-item';
import { IBaseComponent } from '../../configurator/i-base-component';
import { Accessory } from 'src/app/models/configurators-2d/applications/decking-boards/accessory';
import { ConfigurationAccessory } from 'src/app/models/configurators-2d/applications/decking-boards/configuration-accessory';

@Component({
  selector: 'ng-decking-boards-accessories',
  templateUrl: './accessories.component.html',
})
export class DeckingBoardsAccessoriesComponent extends DeckingBoardsConfiguratorItem implements OnInit, IBaseComponent {
  accessories: Accessory[];

  supplies: Supply[];

  currentLang: string;

  //URL de base des images
  baseImgURL: string = undefined;

  constructor(
    private translate: TranslateService,
    deckingBoardsService: DeckingBoardsService
  ) {
    super(deckingBoardsService);
    this.baseImgURL = this.service.apiUrl;
  }

  ngOnInit(): void {
    this.currentLang = this.translate.getBrowserLang();
    this.service.getSupplies().then(supplies => (this.supplies = supplies));
    this.service
      .getAccessories(this.configuration.joist.joistType, this.configuration.location.id, this.configuration.deckingBoardType.id)
      .then(accessories => {
        this.accessories = accessories;
        this.configuration.configurationAccessories = [];
        // Ajout des accessoires par défaut.
        this.accessories.forEach(access => {
          this.configuration.configurationAccessories.push(new ConfigurationAccessory(access.id));
        });
      });
  }

  /**
   * Fonction d'affichage de la sélection de l'accessoire
   * @param id de la type de pose
   * @returns boolean
   */
  isAccessorySelected(id: number): boolean {
    return this.configuration?.configurationAccessories?.find(a => a.accessoryId === id) !== undefined;
  }

  /**
   * Fonction de sélection de l'accessoire
   * @param accessory
   */
  selectAccessory(accessory: Accessory) {
    let accessories = this.configuration.configurationAccessories;
    // si l'accessoire est dans la liste, on le supprime
    if (this.configuration?.configurationAccessories?.find(a => a.accessoryId === accessory.id) !== undefined) {
      accessories = this.configuration?.configurationAccessories.filter(a => a.accessoryId !== accessory.id);
    }
    // si l'accessoire n'est pas dans la liste, on l'ajoute
    else {
      accessories.push(new ConfigurationAccessory(accessory.id));
    }

    this.configuration.configurationAccessories = accessories;
  }

  /**
   * Fonction d'affichage des accessoires
   */
  displayAccessories(): Accessory[] {
    return this.accessories;
  }

  isNextButtonActive(): boolean {
    return true;
  }

  /**
   * Fonction qui vérifie si la lame est valide
   * Soit le devis est valide
   * Sinon elle ne doit pas être disable
   */
  isDeckingBoardValid(): boolean {
    return (
      this.configuration.hasValidQuotation ||
      (this.configuration.deckingBoard !== null && !this.configuration.deckingBoard.isDisabled)
    );
  }

  /**
   * Fonction qui vérifie si la lambourde est valide$
   * Soit le devis est valide
   * Sinon elle ne doit pas être disable
   * Et la lame doit être valide.
   */
  isJoistValid() {
    return (
      this.configuration.hasValidQuotation ||
      (this.isDeckingBoardValid() && this.configuration.joist !== null && !this.configuration.joist.isDisabled)
    );
  }

  checkPageChangeCapability(): boolean {
    let hasDeckingBoardSelected = this.configuration.deckingBoardType != null && this.isDeckingBoardValid();

    // Sélection auto de la finition dans le back donc plus de vérification
    let hasFinishingSelected = true;
    // if (this.configuration.configurationSides.filter(s => s.hasFinishing).length == 0) {
    //   hasFinishingSelected = true;
    // }
    // if (this.configuration.deckingBoardType?.type == DeckingBoardTypeEnum.wood || this.configuration.deckingBoardFinishing != null) {
    //   hasFinishingSelected = true;
    // }

    // Lambourde et fixation sélectionnée
    let hasJoistSelected = this.isJoistValid();
    let hasFixationGroupSelected = this.configuration.fixationGroup != null;

    return hasDeckingBoardSelected && hasFinishingSelected && hasJoistSelected && hasFixationGroupSelected;
  }
}
